<template>
  <div class="Client">
    <banner img="../assets/img/bgtop.jpg" title="客户服务" />
    <div class="Client-product">
      <div class="Client-product-content">
        <div class="editor-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "Client",
  components: {
    Banner
  },
  data() {
    return {
      content: "",
    };
  },
  created() {
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.http
        .get(`/basic/client`)
        .then(response => {
          this.content = this.convertEditorContent(response.data);
        })
        .catch(function (error) {
          window.console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.Client {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #002057;

  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;

    // border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;

      .editor-content {
        width: 100%;
      }
    }
  }
}
</style>